import React, { ReactElement } from 'react';
import './SimulPubItem.scss';
import InkyPenProgressBar from '../../../InkyPenUIKit/InkyPenProgressBar/InkyPenProgressBar';
import { Product } from '../../../../Models/Product';
import { ReadOrPurchaseButton } from '../ComicInfo/Volume/VolumeItem';
import dayjs from 'dayjs';
import { useAtomValue } from 'jotai';
import { LoginStatusAtom } from '../../../../store/AccountStore';


interface SimulPubItemProps {
    isInkypenPlus: boolean;
    chapter: Product;
    showPublishDate?: boolean;
}


function SimulPubItem(props: SimulPubItemProps): ReactElement {
    const digitalVariant = props.chapter.getDigitalVariant();
    const loginStatus = useAtomValue(LoginStatusAtom);

    const isLocked = (): boolean => {
        if(props.chapter.readable.isOwned) {
            return false; //Owned items can always be read.
        }
        return digitalVariant?.priceType === "NotForSale" || digitalVariant?.isComingSoon;
    };

    function isFreeButNotOwned() {
        return !props.chapter.readable.isOwned && (digitalVariant?.priceType === "Free" || digitalVariant?.priceType === "FreeForRegistered");
    }



    // console.log('condition', chapter.chapterNumber, unlockText, isLocked());

    const progress = 100 * props.chapter.readable.readingProgress / (props.chapter.readable.pageCount - 1);


    console.log('props.chapter?.getDigitalVariant()?.priceType', props.chapter?.getDigitalVariant()?.priceType);
    return (
        <div className={`series-pub-item-container`}>
            <div className={`series-pub-item-info-container`}>
                <div
                    className={`series-pub-item-info ${props.chapter?.getDigitalVariant()?.priceType === 'FreeForRegistered' && !props.chapter?.canReadDigitalByUser(loginStatus === 'LoggedIn') && 'series-pub-item-container-free-for-registered'}`}>
                    <span
                        className={`series-pub-item-info-title
                        ${isLocked() && 'series-pub-item-info-title-locked'} 
                        ${isFreeButNotOwned() && 'series-pub-item-info-title-free'}`}>
                        <span className={`series-chapter-progress-info-title`}>
                            {props.chapter?.relativeName}
                        </span>
                        { digitalVariant?.priceType === 'Free' && (<span className={`series-chapter-progress-free`}> | FREE!</span>)}
                        {props.showPublishDate && (
                            <span className={`series-chapter-progress-info-date`}>
                                {dayjs(props.chapter?.publishDate).format('MMM DD, YYYY')}
                            </span>
                        )}
                    </span>

                    <div className='series-pub-item-info-plus-wrapper'>
                    </div>

                </div>
                <ReadOrPurchaseButton product={props.chapter} className={'read-or-purchase-chapter'}/>
            </div>
            <div className='series-pub-item-progress-wrapper'>
                {/* Commented out for QA */}
                {/*{(ownsChapter || volumeOwned) && <InkyPenProgressBar fill={progress} />}*/}
                <InkyPenProgressBar fill={progress} />
            </div>
        </div>
    );
};

export default SimulPubItem;
